<template>
	<!-- preview of item extra photos -->
	<div class="scroll-box-horizontally">
		<div class="row">
			<div class="col-12 d-inline-flex">
				<div @click.prevent="emitPhotosPreviewFxn(index)" v-for="(photo, index) in images" :key="index" class="clickable mr-2">
					<div class="listing-img-thumb rounded" v-bind:style="{ backgroundImage: 'url(' + photo + ')' }"></div>
				</div>
			</div>
		</div>
	</div>
</template>
 
<script>
import { appendImgHostUrl } from '@/store/dry'

export default {
	name: "ItemExtraPhotos",
	props: {
		photos: {
			type: Array,
			require: true
		},
		itemId: {
			type: String,
			require: true
		},
		itemTitle: {
			type: String,
			require: true
		},
	},
	data() {
		return {
			photoHolder: require('../../../../../public/img/web/anewitem-noimage.jpg'),
			images: [],
		}
	},
	methods: {
		extractedItemPhotos(itemPhotos) {
            if(itemPhotos){
				let src = ""
                for(let x=0; x < itemPhotos.length; x++){
					if(itemPhotos[x].thumbPath){
						src = appendImgHostUrl(itemPhotos[x].thumbPath)
					}else{
						src = this.photoHolder
					}
					this.images.push(src)
                }
            }else{
				this.images.push(this.photoHolder)
			}
        },
		emitPhotosPreviewFxn(imageIndex) {
			// emit to re-route to photos album preview page
			this.$emit('emitPhotosPreviewFxn', imageIndex)
		}
	},
	computed: {
		photoCount() {
			return this.images.length
		},
		bgImg() {
			if(this.images.length > 0){
				return this.images[0]
			}else{
				return this.photoHolder
			}
		}
	},
	watch: {
        photos() {
			this.images = []
            this.extractedItemPhotos(this.photos)
        },
    },
	created() {
		this.extractedItemPhotos(this.photos)
	}
}
</script> 